import { useRecoilValue } from 'recoil';

import { getLocationByIdState } from '@/state/locations';
import { getPreferredIdentifier } from '@/utils/helpers';
import { tv } from '@/utils/styles';

interface JourneyLegTabProps {
  index: number;
  fromId: string;
  toId: string;
  isOnlyLeg?: boolean;
  singleLegString?: string;
  multipleLegString?: string;
}

const JourneyLegTab = ({
  index,
  fromId,
  toId,
  isOnlyLeg = false,
  singleLegString = 'Flights from ',
  multipleLegString = 'Flight ',
}: JourneyLegTabProps) => {
  const from = useRecoilValue(getLocationByIdState(fromId));
  const to = useRecoilValue(getLocationByIdState(toId));
  const fromIdentifier = getPreferredIdentifier(from.identifiers);
  const toIdentifier = getPreferredIdentifier(to.identifiers);

  const { badge } = styles();

  return (
    <span>
      {isOnlyLeg ? singleLegString : `${multipleLegString}${index + 1} `}
      <span className={badge()}>
        <b className="font-semibold">{fromIdentifier?.value}</b> to{' '}
        <b className="font-semibold">{toIdentifier?.value}</b>
      </span>
    </span>
  );
};

const styles = tv({
  slots: {
    badge: 'rounded bg-lightBlue-50 px-2 py-1',
  },
});

export { JourneyLegTab };
